import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";

import { CreditOffersGroup } from "./CreditOffersGroup/CreditOffersGroup";
import { Disclaimer } from "./Disclaimer";
import { CreditIllustration } from "@/types/cobeTypes";
import { NonEmptyArray } from "@/types/helpers.ts";

const getCreditOffersByType = (creditOffers: CreditIllustration[]) => {
  const ibcOffersGroups: CreditIllustration[][] = [];
  const ifcOffers: CreditIllustration[] = [];

  creditOffers.forEach((creditOffer: CreditIllustration) => {
    if (creditOffer.financialProductType === "IFC") ifcOffers.push(creditOffer);

    if (creditOffer.financialProductType === "IBC") {
      const targetGroup = ibcOffersGroups.find(
        (ibcOffersGroup) =>
          ibcOffersGroup[0]?.creditRate.value === creditOffer.creditRate.value,
      );
      targetGroup
        ? targetGroup.push(creditOffer)
        : ibcOffersGroups.push([creditOffer]);
    }
  });
  return { ibcOffersGroups, ifcOffers };
};

const groupedCreditOffers = (creditOffers: CreditIllustration[]) => {
  const orderedOffers: Array<NonEmptyArray<CreditIllustration>> = [];
  creditOffers.forEach((creditOffer: CreditIllustration) => {
    const targetGroup = orderedOffers.find((group) => {
      const prevCreditOffer = group[group.length - 1];
      return (
        prevCreditOffer?.financialProductType ==
          creditOffer.financialProductType &&
        prevCreditOffer?.creditRate.value == creditOffer.creditRate.value
      );
    });
    targetGroup
      ? targetGroup.push(creditOffer)
      : orderedOffers.push([creditOffer]);
  });
  return orderedOffers;
};

interface PaymentPlansDrawerProps {
  handleClose: () => void;
  drawerIsOpen: boolean;
  creditOffers: CreditIllustration[];
  ifcDisclaimerAnalyticsClickHandler?: (subtype: string) => void;
  ibcDisclaimerAnalyticsClickHandler?: (subtype: string, type: string) => void;
}

export const PaymentPlansDrawer = ({
  handleClose,
  drawerIsOpen,
  creditOffers,
  ifcDisclaimerAnalyticsClickHandler,
  ibcDisclaimerAnalyticsClickHandler,
}: PaymentPlansDrawerProps) => {
  const { ifcOffers, ibcOffersGroups } = getCreditOffersByType(creditOffers);

  const handleDisclaimerClick = () => {
    if (ifcOffers.length && ifcDisclaimerAnalyticsClickHandler) {
      ifcDisclaimerAnalyticsClickHandler(
        "payment plans credit component - find out more",
      );
    } else if (ibcOffersGroups.length && ibcDisclaimerAnalyticsClickHandler) {
      ibcDisclaimerAnalyticsClickHandler(
        "payment plans fs slide draw - find out more",
        "credit info",
      );
    }
  };
  const groupedOffers = groupedCreditOffers(creditOffers);

  return (
    <Drawer
      isOpen={drawerIsOpen}
      onClose={handleClose}
      heading="John Lewis Money credit options"
    >
      {groupedOffers.map((creditGroup, index) => {
        return (
          <CreditOffersGroup
            creditOfferGroup={creditGroup}
            type={creditGroup[0].financialProductType}
            key={index}
          />
        );
      })}

      <Disclaimer disclaimerClickHandler={handleDisclaimerClick} />
    </Drawer>
  );
};
